import React from 'react';
import { Stack } from '@mui/material';
import type OptionsList from '../OptionsList';
import { OPTIONS_STYLES } from '../../../constants/waivers';
import AutoWidthInput from '../../form/base/AutoWidthInput';
import { WaiverOption } from '../../../types/waivers';

type ListProps = React.ComponentProps<typeof OptionsList>;

export default function CheckboxOption({
  disabled,
  item,
  options,
  onChange,
  placeholder,
}: {
  disabled: ListProps['disabled'];
  item: WaiverOption;
  options: ListProps['options'];
  onChange: ListProps['onChange'];
  placeholder: ListProps['placeholder'];
}) {
  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      maxWidth="100%"
      boxSizing="border-box"
      gap={`${OPTIONS_STYLES.gap}px`}
      p="16.5px 14px">
      <div
        style={{
          width: `${OPTIONS_STYLES.leftItemWidth}px`,
        }}>
        <Stack
          mr={0.5}
          flexShrink={0}
          width="22px"
          height="22px"
          border={theme => `1px solid ${theme.palette.lightOutlineGrey.main}`}
          sx={{
            cursor: 'pointer',
          }}
        />
      </div>
      <Stack maxWidth={`calc(100% - ${OPTIONS_STYLES.leftItemWidth}px)`}>
        <AutoWidthInput
          disabled={disabled}
          extraWidth={item.text ? 14 : placeholder.length}
          placeholderExtraWidth={14}
          placeholderIsMinWidth={!item.text}
          value={item.text}
          onChange={e => {
            const newOptions = options.map(option =>
              option.id === item.id
                ? { ...option, text: e.target.value }
                : option,
            );
            onChange(newOptions);
          }}
          placeholder={placeholder}
        />
      </Stack>
    </Stack>
  );
}
